import React from "react";
import { Button, Modal } from "react-bootstrap";

export const BatchWarningModal = ({ t, show, onCancel, onConfirm, batchWarning }) => (
	<Modal show={show} onHide={onCancel} centered>
		<Modal.Header closeButton>
			<Modal.Title>{t("Batch Quantity Limit")}</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<p>
				{t("No more quantity available for batch")} <b>{batchWarning.batch?.batchNumber}</b>.
				<br />
				{t("To add more, please select a new batch")}.
			</p>
		</Modal.Body>
		<Modal.Footer>
			<Button variant="secondary" onClick={onCancel}>
				{t("Cancel")}
			</Button>
			<Button variant="primary" onClick={onConfirm}>
				{t("Add New Batch Entry")}
			</Button>
		</Modal.Footer>
	</Modal>
);

export default BatchWarningModal;

